import React, { Component } from "react";
import PropTypes from "prop-types";
import ButtonGroup from "./button-group";
import { getCaseCount as getCaseCountPTAB } from "../../services/api-ptab";
import { getCaseCount as getCaseCountLitigation } from "../../services/api-maxval";
import { startCase } from "lodash";

class CaseCountsContainer extends Component {
  static propTypes = {
    queries: PropTypes.arrayOf(PropTypes.array).isRequired, // array of tuples (name, query)
    type: PropTypes.oneOf(["ptab", "litigation"]).isRequired
  };

  state = {}; // will be populated by `queries` props

  componentDidMount() {
    this._isMounted = true;
    const apiCall = this.props.type === "litigation" ? getCaseCountLitigation : getCaseCountPTAB;
    this.props.queries.forEach(([name, query]) => {
      if (this._isMounted)
        this.setState({
          [name]: null,
          [name + "Loading"]: true
        });
      apiCall(query)
        .then(cnt => {
          if (this._isMounted)
            if (this._isMounted)
              this.setState({
                [name]: cnt,
                [name + "Loading"]: false
              });
        })
        .catch(err => {
          if (this._isMounted)
            if (this._isMounted)
              this.setState({
                [name + "Error"]: err.message
              });
        });
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const countItems = this.props.queries.map(([name, query]) => ({
      primaryText: <div>{this.state[name]}</div>,
      secondaryText: startCase(name),
      path: this.props.type === "litigation" ? "/litigation/caselist" : "/ptab/caselist",
      query
    }));
    return <ButtonGroup items={countItems} />;
  }
}

export default CaseCountsContainer;
